//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './DocumentClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type ConvertToPdfDocumentMutationParameters = {
  docFile?: Types.FileParameter | null | undefined ;
}

export type UpdateDocumentHeaderAndFooterDocumentQueryParameters = {
  templateId: number ;
  patientId: number ;
}

export type GetSingleDocumentQueryParameters = {
  id: number ;
}

export function convertToPdfUrl(): string {
  let url_ = getBaseUrl() + "/api/documents/to-pdf";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function convertToPdfMutationKey(): MutationKey {
  return trimArrayEnd([
      'DocumentClient',
      'convertToPdf',
    ]);
}

export function useConvertToPdfMutation<TContext>(options?: Omit<UseMutationOptions<Types.FileResponse, unknown, ConvertToPdfDocumentMutationParameters, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.FileResponse, unknown, ConvertToPdfDocumentMutationParameters, TContext> {
  const key = convertToPdfMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (convertToPdfDocumentMutationParameters: ConvertToPdfDocumentMutationParameters) => Client.convertToPdf(convertToPdfDocumentMutationParameters.docFile),
    mutationKey: key,
  });
}
  
export function updateDocumentHeaderAndFooterUrl(templateId: number, patientId: number): string {
  let url_ = getBaseUrl() + "/api/documents/update-header-and-footer/{templateId}/{patientId}";
if (templateId === undefined || templateId === null)
  throw new Error("The parameter 'templateId' must be defined.");
url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
if (patientId === undefined || patientId === null)
  throw new Error("The parameter 'patientId' must be defined.");
url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updateDocumentHeaderAndFooterMutationKey(templateId: number, patientId: number): MutationKey {
  return trimArrayEnd([
      'DocumentClient',
      'updateDocumentHeaderAndFooter',
      templateId as any,
      patientId as any,
    ]);
}

export function useUpdateDocumentHeaderAndFooterMutation<TContext>(templateId: number, patientId: number, options?: Omit<UseMutationOptions<string, unknown, Types.ContentDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<string, unknown, Types.ContentDto, TContext> {
  const key = updateDocumentHeaderAndFooterMutationKey(templateId, patientId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.ContentDto) => Client.updateDocumentHeaderAndFooter(templateId, patientId, dto),
    mutationKey: key,
  });
}
  
type UpdateDocumentHeaderAndFooter__MutationParameters = UpdateDocumentHeaderAndFooterDocumentQueryParameters & {
  dto: Types.ContentDto;
}

export function useUpdateDocumentHeaderAndFooterMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<string, unknown, UpdateDocumentHeaderAndFooter__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: UpdateDocumentHeaderAndFooterDocumentQueryParameters}): UseMutationResult<string, unknown, UpdateDocumentHeaderAndFooter__MutationParameters, TContext> {
  const key = updateDocumentHeaderAndFooterMutationKey(options?.parameters?.templateId!, options?.parameters?.patientId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: UpdateDocumentHeaderAndFooter__MutationParameters) => Client.updateDocumentHeaderAndFooter(data.templateId ?? options?.parameters?.templateId!, data.patientId ?? options?.parameters?.patientId!, data.dto),
  mutationKey: key,
});
}
  
export function getSingleUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/documents/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getSingleDefaultOptions: Omit<UseQueryOptions<Types.TemplateDto, unknown, Types.TemplateDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.TemplateDto, unknown, Types.TemplateDto>, 'queryFn'>> = {
};
export function getGetSingleDefaultOptions() {
  return getSingleDefaultOptions;
};
export function setGetSingleDefaultOptions(options: typeof getSingleDefaultOptions) {
  getSingleDefaultOptions = options;
}

export function getSingleQueryKey(id: number): QueryKey;
export function getSingleQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetSingleDocumentQueryParameters;

    return trimArrayEnd([
        'DocumentClient',
        'getSingle',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'DocumentClient',
        'getSingle',
        ...params
      ]);
  }
}
export function __getSingle(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getSingle(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetSingleQuery<TSelectData = Types.TemplateDto, TError = unknown>(dto: GetSingleDocumentQueryParameters, options?: Omit<UseQueryOptions<Types.TemplateDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets full information (including Content) of a single GDT Template
 */
export function useGetSingleQuery<TSelectData = Types.TemplateDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.TemplateDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetSingleQuery<TSelectData = Types.TemplateDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.TemplateDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetSingleDocumentQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.TemplateDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getSingle(context, axiosConfig) : __getSingle,
    queryKey: getSingleQueryKey(id),
    ...getSingleDefaultOptions as unknown as Omit<UseQueryOptions<Types.TemplateDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets full information (including Content) of a single GDT Template
 */
export function setGetSingleData(queryClient: QueryClient, updater: (data: Types.TemplateDto | undefined) => Types.TemplateDto, id: number) {
  queryClient.setQueryData(getSingleQueryKey(id),
    updater
  );
}

/**
 * Gets full information (including Content) of a single GDT Template
 */
export function setGetSingleDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.TemplateDto | undefined) => Types.TemplateDto) {
  queryClient.setQueryData(queryKey, updater);
}